module.exports = __webpack_public_path__ + "img/courier-centraltransport.af539e72.svg";